import { render, staticRenderFns } from "./DatePickerForAltCalcs.vue?vue&type=template&id=53c6ecb3&scoped=true"
import script from "./DatePickerForAltCalcs.vue?vue&type=script&lang=ts"
export * from "./DatePickerForAltCalcs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c6ecb3",
  null
  
)

export default component.exports